import { render, staticRenderFns } from "./printWJSales.vue?vue&type=template&id=f8c4f8e2&scoped=true&"
import script from "./printWJSales.vue?vue&type=script&lang=js&"
export * from "./printWJSales.vue?vue&type=script&lang=js&"
import style0 from "./printWJSales.vue?vue&type=style&index=0&id=f8c4f8e2&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c4f8e2",
  null
  
)

component.options.__file = "printWJSales.vue"
export default component.exports